export default __webpack_public_path__ + "static/media/blue-observed.5b9b6a81.svg";